export const SET_COMMENTS = 'SET_COMMENTS';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const ADD_COMMENT = 'ADD_COMMENT';
export const UPDATE_COMMENT = 'UPDATE_COMMENT';
export const UPDATE_COMMENTS = 'UPDATE_COMMENTS';
export const DELETE_COMMENTS = 'DELETE_COMMENTS';
export const CREATE_COMMENTS = 'CREATE_COMMENTS';
